<template>
  <v-row>
    <input-select
      v-if="tipoCampo"
      v-model="form.tipoCampo"
      class="col-12"
      :options="tipoCampo"
    />
    
    <input-condicional
      v-model="form.valorPadrao"
      :input-selecionado="form.tipoCampo"
      :form="form"
      class=" col-md-12 col-12 remove"
      :label="'teste'"
    />
  </v-row>
</template>
      
<script>
import EnumeradorService from '@common/services/cadastros/EnumeradorService';
import { CampoAdicionalModel } from '@common/models/cadastros/CampoAdicionalModel.js';
import InputCondicional from '../../../../cadastros/campo_adicional/componentes/InputCondicional.vue';

export default {
    components:{
        InputCondicional
    },
    props:{
        criterio: {
          default: '',
          required: false,
        }
    },
    data() {
        return {
            selectedItem: null,
            items: [],
            loading: false,
            opcoes: {},
            tipoCampo:'',
            form: new CampoAdicionalModel({}),

        };
    },
    watch:{
        'form.valorPadrao'(valor){
            let criterios = this.$store.getters['criterios/getCriterios']
            const itemEncontrado = criterios.find(item => item.sequencia === this.criterio.sequencia);
            
            if(itemEncontrado) {
                itemEncontrado.valor =  valor
                this.$store.dispatch('criterios/updateCriterio', {updatedCriterio: itemEncontrado});
            }
        }
    },
    async mounted() {
        await this.buscarTipoCampoEnum();
    },
    methods: {
        buscarTipoCampoEnum: async function () {
            await EnumeradorService.buscar('EnumCampoAdicionalTipoCampo').then((res) => {
                this.tipoCampo = res;
            });
        },
    }
};
</script>
<style lang="css" scoped>
.remove .v-label--externo .label {
    display: none !important;
    background-color: gray;
}
</style>